{
    "PartitionList_Column_Description": "Description",
    "PartitionList_Column_IDInTelSys": "ID",
    "PartitionList_Column_Licence": "Licence",
    "PartitionList_Column_Extensions": "Extensions",
    "PartitionList_Column_AcdAgents": "Agents",
    "PartitionList_Column_AppUsers": "Users",
    "PartitionList_Column_SyncType": "Sync Type",
    "PartitionList_Column_Status": "Status",
    "PartitionList_Filter_Licence": "Licence",
    "PartitionList_CountLink_ExtensionsAria": "View devices in this partition",
    "PartitionList_CountLink_AcdAgentsAria": "View ACD agents in this partition",
    "PartitionList_CountLink_AppUsersAria": "View app users in this partition",
    "PartitionList_Add_Disabled_SelectTelephonyServer": "Select a telephony server to add a partition.",
    "NAME": "PartitionListLanguage"
}
